// extracted by mini-css-extract-plugin
export default {"AdSlotOffsite":"bhc_a bib_bi"};